/* import React from 'react'; */
import { Link } from "react-router-dom";
import Header from '../header/header';
import Footer from '../footer/footer';
import "./layout.scss";
const Layout = (props: any) => {
    return (<>
        <main className=" overflow-x-hidden">
            <Header />
            {props.children}
            {/* <Footer /> */}
        </main>
    </>);
}

export default Layout;